<template>
  <div class="Box" style="margin: 30px 50px 0 70px">
    <div class="Box_left">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="RuleForm"
        label-width="100px"
        class="demo-ruleForm"
        hide-required-asterisk
      >
        <el-form-item label="充值人VIP号 " prop="vipCode">
          <el-input
            v-model="ruleForm.vipCode"
            placeholder="请输入用户的VIP号"
            @input="getVipCode"
          ></el-input>
          <div class="Box_accountMsg">
            <div class="exit msg" v-show="userDate.vipCode !== undefined">
              <div class="exit_left">
                <div class="tag tag1">用户名</div>
                <div class="tag tag2">真实姓名</div>
                <div class="tag tag3">VIP号</div>
                <div class="tag tag4">手机号</div>
                <div class="tag tag5">余额</div>
              </div>
              <div class="exit_right">
                <div class="exit_right_text" style="color: #ffd700">
                  {{ userDate.nickname }}
                </div>
                <div class="exit_right_text" style="color: #dc143c">
                  {{ userDate.realName }}
                </div>
                <div class="exit_right_text code">
                  {{ userDate.vipCode }}
                </div>
                <div class="exit_right_text">
                  {{ userDate.mobile }}
                </div>
                <div class="exit_right_text" style="color: green">
                  {{ userDate.balance }}
                </div>
              </div>
            </div>
            <div
              class="nexit msg"
              v-show="userDate.vipCode == undefined && getLength() > 0"
            >
              暂无数据
            </div>
          </div>
        </el-form-item>
        <el-form-item label="收款账户" prop="accountName">
          <el-select
            v-model="paidSearch.accountId"
            clearable
            placeholder="收款方式"
            style="width: 37%"
            @change="init()"
          >
            <el-option
              v-for="(item, index) in paidCount"
              :key="index"
              :label="item.accountName"
              :value="item.accountId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="实际收费" prop="actualAmount">
          <el-input
            class="money_input"
            v-model="ruleForm.actualAmount"
            @input="rateChange"
            type="number"
            clearable
          ></el-input>
          <el-select
            v-model="currency.currencyType"
            placeholder="货币类型"
            @change="rateChange()"
            style="width: 150px"
          >
            <el-option
              v-for="(item, index) in currencyTypeSelect"
              :key="index"
              :label="item.currency"
              :value="item.currencyType"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="充值金额" prop="amount">
          <el-input
            class="money_input"
            v-model="ruleForm.amount"
            type="number"
          ></el-input>
          <el-input class="money_input_out" v-model="CAD" disabled></el-input>
        </el-form-item>
        <el-form-item label="操作人">
          <el-input disabled v-model="realName"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="name">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4 }"
            placeholder="可输入备注内容"
            v-model="textarea2"
          >
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div style="width: 100%; text-align: center">
      <el-button type="primary" @click="sendBt"> 提 交 </el-button>
    </div>
    <div class="panel" v-if="ruleForm.vipCode && userBalancesPojos">
      <div class="panel_title">| 最近五次交易流水(CAD)</div>
      <div class="panel_msg">
        <el-table :data="userBalancesPojos" stripe>
          <el-table-column
            prop="balanceNo"
            label="流水号"
            width="150"
            align="center"
          >
          <template slot-scope="scope">
            <span style="font-size:10px">
                {{
                scope.row.balanceNo
              }}
              </span>
          </template>
          </el-table-column>
          <el-table-column
            min-width="60"
            align="center"
            prop="amount"
            label="金额"
          >
          <!-- balanceType为2表示充值 1表示支出 -->
            <template slot-scope="scope">
              <span v-if="scope.row.balanceType == 2" style="color:red">
                -{{scope.row.amount}}
              </span>
              <span v-if="scope.row.balanceType == 1" style="color:green">
                +{{scope.row.amount}}
              </span>
              <span v-if="scope.row.balanceType == 3">
                <span v-if="scope.row.orderNo.indexOf('上')!== -1" style="color:green">
                  +{{scope.row.amount}}
                </span>
                <span v-if="scope.row.orderNo.indexOf('下')!== -1" style="color:red">
                  -{{scope.row.amount}}
                </span>
              </span>
            </template>
          </el-table-column>
          
          <el-table-column align="center" label="时间" width="140">
            <template slot-scope="scope">
              <span style="font-size:10px">
                {{
                scope.row.operatorTime
                  ? changeDate(scope.row.operatorTime)
                  : "时间未知"
              }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="afterBalance"
            min-width="80"
            align="center"
            label="剩余金额"
          >
          <template slot-scope="scope">
            <span style="font-size:10px">
                {{
                scope.row.afterBalance
              }}
              </span>
          </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import * as mUtils from "../../utils/mUtils";
import * as charge from "../../api/charge";
export default {
  data() {
    return {
      ruleForm: {
        vipCode: "",
        accountName: "",
        actualAmount: "",
        amount: "",
      },
      rules: {
        vipCode: [
          { required: true, message: "请输入充值人VIP号", trigger: "blur" },
          { min: 6, message: "长度为6个字符", trigger: "blur" },
        ],
        actualAmount: [
          { required: true, message: "请输入实际收费", trigger: "blur" },
        ],
        amount: [
          { required: true, message: "请输入充值金额", trigger: "blur" },
        ],
      },
      rateList: [],
      CAD: "CAD",
      currency: {
        currencyType: 1,
      },
      paidCount: [],
      paidSearch: {
        accountId: null,
      },
      userDate: {},
      realName: "",
      textarea2: "",
      currencyTypeSelect: [
        {
          currencyType: 1,
          currency: "￥",
        },
        {
          currencyType: 2,
          currency: "$",
        },
        {
          currencyType: 3,
          currency: "C$",
        },
      ],
      disCount: "",
      // 流水记录
      userBalancesPojos: null,

    };
  },
  created() {
    this.getlist();
    this.getAccountList();
    this.getRateList();
    this.getDiscount();
  },
  methods: {
    init() {},
    getlist() {
      this.userDate = mUtils.getStore("userinfo");
      this.realName = this.userDate.realName;
    },
    getDiscount() {
      let param = {};
      charge.getDiscount(param).then((res) => {
        if (res.status !== 200)
          return this.$message.error("获取优惠列表失败：" + res.msg);
        if (res.data.code !== 0)
          return this.$message.error("获取优惠列表失败：" + res.data.msg);
        this.disCount = res.data.data.title;
      });
    },
    getRateList() {
      let param = {};
      charge.getRateList(param).then((res) => {
        if (res.status !== 200) return this.$message.error("获取汇率列表失败");
        if (res.data.code !== 0) return this.$message.error("参数错误");
        this.rateList = res.data.data.list;
      });
    },
    getAccountList() {
      let param = {};
      charge.getAccountList(param).then((res) => {
        if (res.status !== 200) return this.$message.error("获取账户列表失败");
        if (res.data.code !== 0) return this.$message.error(res.data.msg);
        else {
          this.paidCount = res.data.data.list;
        }
      });
    },
    getVipCode() {
      this.userDate = {};
      this.userBalancesPojos = null;
      let param = {
        vipCode: this.ruleForm.vipCode,
      };
      if (param.vipCode.length > 5) {
        charge.getVipCode(param).then((res) => {
          if (res.data.data) {
            this.userDate = res.data.data;
            if (res.data.data.userBalancesPojos) {
              this.userBalancesPojos = res.data.data.userBalancesPojos;
            }
          }
        });
      }
    },
    getLength() {
      return this.ruleForm.vipCode.length;
    },
    rateChange() {
      console.log(this.currency.currencyType);
      if (this.currency.currencyType == 1) {
        this.ruleForm.amount = (
          this.rateList[0].rate *
          (this.ruleForm.actualAmount - 0)
        ).toFixed(2);
      } else if (this.currency.currencyType == 2) {
        this.ruleForm.amount = (
          this.rateList[1].rate *
          (this.ruleForm.actualAmount - 0)
        ).toFixed(2);
      } else if (this.currency.currencyType == 3) {
        this.ruleForm.amount = (this.ruleForm.actualAmount - 0).toFixed(2);
      }
    },
    sendBt() {
      let curr = null;
      if (this.currency.currencyType == 1) curr = "CNY";
      else if (this.currency.currencyType == 2) curr = "USD";
      else if (this.currency.currencyType == 3) curr = "CAD";
      let param = {
        vipCode: this.ruleForm.vipCode,
        accountId: this.paidSearch.accountId,
        currency: curr,
        actualAmount: this.ruleForm.actualAmount - 0,
        amount: this.ruleForm.amount - 0,
        remark: this.textarea2,
      };
      console.log(param);
      let b = null;
      this.$refs.RuleForm.validate((vali) => {
        b = vali;
      });
      if (this.ruleForm.actualAmount - 0 < 0)
        return this.$message.error("充值金额不能为负，请重新输入");
      if (b) {
        charge.deposit(param).then((res) => {
          console.log(res);
          if (res.status !== 200)
            return this.$message.error("提交充值信息失败");
          if (res.data.code !== 0) return this.$message.error(res.data.msg);
          else {
            this.$message.success("提交充值信息成功");
            this.ruleForm.vipCode = "";
            this.ruleForm.actualAmount = "";
            this.ruleForm.amount = "";
            this.textarea2 = "";
            this.paidSearch.accountId = null;
            this.userDate.vipCode = undefined;
          }
        });
      }
    },
    changeDate(row) {
      return mUtils.formatDate(new Date(row), 4);
    },
  },
};
</script>

<style lang="less" scoped>
.Box {
  position: relative;
}

.el-input {
  width: 38%;
}
.msg {
  margin-top: 5px;
  border-radius: 8px;
  background-color: rgba(238, 238, 238, 0.705);
  width: 38%;
}
.nexit {
  text-align: center;
}
.exit_left {
  margin-left: 20%;
  display: inline-block;
  div {
    line-height: 35px;
  }
}
.exit_right {
  display: inline-block;
  margin-left: 15%;
  .exit_right_text {
    font-size: 18px;
  }
}
.tag {
  border-radius: 4px;
  text-align: center;
  height: 35px;
  margin-top: 5px;
  &.tag1 {
    background-color: #ecf5ff;
    color: #409eff;
    border: 1px solid #d9ecff;
  }
  &.tag2 {
    background-color: #dcf6ce;
    border-color: #e1f3d8;
    color: #67c23a;
  }
  &.tag3 {
    background-color: #fdf6ec;
    border-color: #faecd8;
    color: #e6a23c;
  }
  &.tag4 {
    background-color: #f1df3b;
    border-color: #faf1a3;
    color: #bdae2c;
  }
  &.tag5 {
    background-color: #a3eefa;
    border-color: #a3eefa;
    color: #bdae2c;
  }
}
.code {
  color: #00bfff;
}
.money_input {
  width: 18%;
  margin-right: 10px;
}
.money_input_out {
  width: 8%;
}
.panel {
  position: absolute;
  top: 0%;
  right: -2%;
  .panel_title {
    font-size: 20px;
    margin: 10px 0 20px 30px;
  }
  .panel_msg {
    border-radius: 5px;
    // border: 3px #eee solid;
    display: inline-block;
    padding: 30px;
    width: 500px;
    max-height: 400px;
    overflow-y: auto;
    margin-left: 0px;
    div {
      font-size: 18px;
      color: red;
    }
  }
}
</style>


// WEBPACK FOOTER //
// charge.vue?462f8bda